import PropTypes from 'prop-types';
import TaskSlideout from './TaskSlideout';

// -----------------------------------------------
// TaskModalView (#178) — centered MUI Dialog wrapping the same task body /
// header that the slideout renders. Implemented as a thin wrapper around
// TaskSlideout with `mode="modal"` so we don't fork the body per layout —
// the constraint from the backlog doc (status banner, Properties grid,
// Comments + Attachments must render identically across modes; LeadActionZone
// gating must hold). Only the outer chrome differs: a Dialog (~720px wide on
// desktop, fullScreen on mobile) instead of the right-anchored Drawer.
// -----------------------------------------------

export default function TaskModalView({
    open,
    onClose,
    taskId,
    practiceId,
    onTaskUpdated,
    onDeleteChecklist,
    onOpenFullView,
    onChangeMode,
    taskList,
    onNavigateTask,
}) {
    return (
        <TaskSlideout
            open={open}
            onClose={onClose}
            taskId={taskId}
            practiceId={practiceId}
            onTaskUpdated={onTaskUpdated}
            onDeleteChecklist={onDeleteChecklist}
            onOpenFullView={onOpenFullView}
            mode="modal"
            onChangeMode={onChangeMode}
            taskList={taskList}
            onNavigateTask={onNavigateTask}
        />
    );
}

TaskModalView.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    taskId: PropTypes.string,
    practiceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onTaskUpdated: PropTypes.func,
    onDeleteChecklist: PropTypes.func,
    onOpenFullView: PropTypes.func,
    onChangeMode: PropTypes.func,
    taskList: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])),
    onNavigateTask: PropTypes.func,
};

TaskModalView.defaultProps = {
    taskId: null,
    onTaskUpdated: null,
    onDeleteChecklist: null,
    onOpenFullView: null,
    onChangeMode: null,
    taskList: null,
    onNavigateTask: null,
};
